<template>
  <div>
    <!--<menu_component></menu_component>-->
    <home_component></home_component>
    <mode_component></mode_component>
    <ebill_component></ebill_component>
    <meters_component></meters_component>
    <reports_component></reports_component>
    <footer_component></footer_component>
    <div class="end"></div>
  </div>
</template>

<script>
//import menu_component from './components/menu.vue';
import home_component from './components/home.vue';
import mode_component from './components/mode.vue';
import ebill_component from './components/ebill.vue';
import meters_component from './components/meters.vue';
import reports_component from './components/reports.vue';
import footer_component from './components/footer.vue';
export default {
  name: 'App',
  components:{
    //menu_component,
    home_component,
    mode_component,
    ebill_component,
    meters_component,
    reports_component,
    footer_component
  },
  mounted() {
    setTimeout(() => {
      document.querySelector(".preloader").style.display = 'none';
    },1000);
  }
}
</script>

<style>

</style>
